import { makeStyles } from '@mui/styles';
import { colors, theme } from '../../theme';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import ListAltIcon from '@mui/icons-material/ListAlt';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { Link } from 'react-router-dom';

const testid = 'home';

const color = colors();
const themes = theme().typography;
export const Home = () => {
	const classes = useStyles();

	return (
		<>
			<Grid container spacing={2} height={'100%'} data-testid={testid}>
				<Grid item xs={12}>
					<div className={classes.home}>
						<Typography {...themes.h2} data-testid={`${testid}-title`} className={classes.header}>
							Welcome to TraceTracker!
						</Typography>
						<Grid
							container
							{...themes.bodyRegular}
							alignItems="center"
							justifyContent="space-evenly"
							height="calc(100% - 150px)"
							padding="30px"
							style={{ height: '100%' }}
						>
							<Grid item xs={4} justifyContent="center" alignItems="center" display="flex">
								<Card
									sx={{
										':hover': {
											boxShadow: 20,
										},
									}}
									component={Link}
									to={'/ruleengine'}
									className={classes.card}
								>
									<CardContent>
										<div className={`${classes.tile} ${classes.centerFlexDiv}`}>
											<ListAltIcon className={classes.icon} />
										</div>
										<Typography className={classes.cardTitle}>
											Material Integrity <br /> Routines & Requirements
										</Typography>
										<Typography {...themes.bodyRegular} className={classes.cardText}>
											Find everything you need for Material Integrity: Requirements, declaration forms, supporting
											document examples, TC guidance, and blending rules. Access a high‑level MI overview and training
											materials.
										</Typography>
									</CardContent>
								</Card>
							</Grid>
							{(localStorage.getItem('isSupplierAccount') !== 'true') && <Grid item xs={4} justifyContent="center" alignItems="center" display="flex">
								<Card
									sx={{
										':hover': {
											boxShadow: 20,
										},
									}}
									component={Link}
									to={'/supplier'}
									className={classes.card}
								>
									<CardContent>
										<div className={`${classes.tile} ${classes.centerFlexDiv}`}>
											<HubOutlinedIcon className={classes.icon} />
										</div>
										<Typography className={classes.cardTitle}>
											Traceability <br /> External Platforms
										</Typography>
										<Typography {...themes.bodyRegular} className={classes.cardText}>
											Explore the various external traceability platforms that H&M Group is using, traceability
											requirements and fibers in scope.
										</Typography>
									</CardContent>
								</Card>
							</Grid>}
							<Grid item xs={4} justifyContent="center" alignItems="center" display="flex">
								<Card
									sx={{
										':hover': {
											boxShadow: 20,
										},
									}}
									component={Link}
									to={'/brandCertification'}
									className={classes.card}
								>
									<CardContent>
										<div className={`${classes.tile} ${classes.centerFlexDiv}`}>
											<WorkspacePremiumIcon className={classes.icon} />
										</div>
										<Typography className={classes.cardTitle}>
											Brand Certificates <br /> & Other Agreements
										</Typography>
										<Typography {...themes.bodyRegular} className={classes.cardText}>
											View and Download the latest Brand Scope Certificates and other certificates and agreements.
										</Typography>
									</CardContent>
								</Card>
							</Grid>
						</Grid>
					</div>
				</Grid>
			</Grid>
		</>
	);
};

const useStyles = makeStyles(() => ({
	home: {
		height: '95%',
		borderBottom: `2px solid ${color.primary[10]}`,
	},
	header: {
		height: '30px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	card: {
		display: 'flex',
		width: '400px',
		height: '300px',
		cursor: 'pointer',
		textDecoration: 'none',
		backgroundColor: 'whitesmoke !important',
	},
	centerFlexDiv: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	flexDiv: {
		display: 'flex',
		alignItems: 'center',
	},
	tile: {
		height: '70px',
	},
	cardTitle: {
		display: 'flex',
		justifyContent: 'center',
		textAlign: 'center',
		paddingBottom: '20px',
		fontWeight: 'bold !important',
		fontSize: '18px !important',
	},
	cardText: {
		display: 'flex',
		justifyContent: 'center',
		textAlign: 'center',
		fontSize: '15px !important',
	},
	icon: {
		width: '35px !important',
		height: '35px !important',
		padding: '10px',
		color: color.shades.white,
		background: `linear-gradient(to bottom, ${color.primary.logoDark}, ${color.primary.logoLight})`,
		borderRadius: '50%',
	},
	footer: {
		position: 'absolute',
		bottom: 0,
		right: 0,
		margin: '0px 20px 10px 20px',
	},
}));
